import { colors } from '../colors.js';
import { space } from '../spacing.js';
import { radii } from '../radius.js';
import { borderStyles, borderWidths } from '../borders.js';
import { zIndices } from '../z-index.js';
export const tab = {
    padding: space.x2,
    tabStates: {
        inactive: {
            color: colors.controls.default,
        },
        hovered: {
            color: colors.controls.primary,
            markerColor: colors.controls.secondaryHover,
        },
        active: {
            color: colors.controls.primaryActive,
            markerColor: colors.controls.primaryActive,
        },
        focussed: {
            color: colors.controls.primary,
            markerColor: colors.controls.secondaryHover,
        },
    },
    tabMarker: {
        borderBottom: {
            style: borderStyles.solid,
            width: borderWidths.md,
            color: colors.controls.secondaryHover,
        },
        borderRadius: {
            topLeft: radii.x1_5,
            topRight: radii.x1_5,
            bottomRight: radii.x0,
            bottomLeft: radii.x0,
        },
        height: '1px',
        width: '100%',
    },
};
export const tabList = {
    padding: space.x1,
    borderBottom: {
        style: borderStyles.solid,
        width: borderWidths.sm,
        color: colors.borders.default,
    },
};
export const tabPanel = {
    background: colors.backgrounds.onGray,
};
export const moreMenuBox = {
    zIndex: zIndices.dropdown,
};
export const moreButtonCaret = {
    marginLeft: space.x2,
};
//# sourceMappingURL=tabs.js.map